export function plainItem(item) {
  return !item.selling_plan_allocation && !item.parent_relationship && !Object.keys(item.properties || {}).length;
}

export function selectOffer(cart, offers) {
  if (!cart.items?.length) return null;
  const has = id => cart.items.some(i => Number(i.variant_id || i.id) === Number(id));
  const candidates = [];
  for (const offer of offers) {
    if (offer.parent && has(offer.parent.id)) continue;
    const matched = offer.items.filter(p => has(p.id));
    const triggered = (offer.triggers || []).some(has);
    if (!matched.length && !triggered) continue;
    if (offer.parent) {
      if (!offer.parent.available || !offer.items.every(p => p.available)) continue;
      if (!cart.items.some(i => Number(i.variant_id || i.id) === Number(offer.items[0]?.id) && plainItem(i))) continue;
      candidates.push({...offer, missing: offer.items.filter(p => !has(p.id)), score: 100});
      continue;
    }
    const missing = offer.items.filter(p => !has(p.id) && p.available);
    if (!missing.length || offer.items.some(p => !has(p.id) && !p.available)) continue;
    candidates.push({...offer, missing, score: matched.length / offer.items.length + (triggered ? .05 : 0)});
  }
  return candidates.sort((a,b) => b.score-a.score || a.missing.reduce((s,p)=>s+p.price,0)-b.missing.reduce((s,p)=>s+p.price,0))[0] || null;
}

export function bundleUpdates(cart, offer) {
  const updates = {};
  for (const p of offer.items) {
    const line = cart.items.find(i => Number(i.variant_id || i.id) === Number(p.id) && plainItem(i));
    if (line) updates[line.key] = line.quantity - 1;
  }
  const existing = cart.items.find(i => Number(i.variant_id || i.id) === Number(offer.parent.id));
  updates[existing?.key || String(offer.parent.id)] = (existing?.quantity || 0) + 1;
  return updates;
}

export function cartFingerprint(cart) {
  return JSON.stringify((cart.items || []).map(i=>[i.key,i.quantity,i.final_line_price]).sort((a,b)=>String(a[0]).localeCompare(String(b[0]))));
}

if (typeof document !== 'undefined') {
  const configNode = document.getElementById('ke-offer-config');
  const dialog = document.getElementById('ke-checkout-offer');
  if (configNode && dialog && typeof dialog.showModal === 'function') {
    const config = JSON.parse(configNode.textContent);
    const root = config.root || '/';
    const $ = s => dialog.querySelector(s);
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:config.currency || 'GBP'}).format(value / 100);
    let current = null, snapshot = null, loading = false, mutating = false, returnFocus = null, originForm = null;
    const api = async (path, body) => {
      const response = await fetch(root + path, {method:body?'POST':'GET',credentials:'same-origin',headers:{'Accept':'application/json',...(body?{'Content-Type':'application/json'}:{})},body:body?JSON.stringify(body):undefined});
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || config.error);
      return result;
    };
    function render(offer) {
      current=offer;
      $('[data-offer-title]').textContent=offer.name;
      $('[data-offer-copy]').textContent=offer.parent ? config.bundleCopy : offer.copy;
      $('[data-offer-items]').replaceChildren();
      const has = id => snapshot.items.some(i=>Number(i.variant_id || i.id)===Number(id));
      for(const p of offer.parent ? offer.items : offer.missing) {
        const row=document.createElement('div');row.className='ke-offer-item';
        const img=document.createElement('img');img.src=p.image;img.alt='';img.width=64;img.height=64;
        const text=document.createElement('div');const title=document.createElement('p');title.textContent=p.title;
        const sub=document.createElement('small');sub.textContent=has(p.id)?config.already:money(p.price);
        text.append(title,sub);row.append(img,text);$('[data-offer-items]').append(row);
      }
      $('[data-offer-price]').textContent=offer.parent ? config.bundlePrice+' '+money(offer.parent.price) : config.addPrice+' '+money(offer.missing.reduce((sum,p)=>sum+p.price,0));
      $('[data-offer-note]').textContent=offer.parent?config.bundleDelivery:config.careDelivery;
      $('[data-offer-accept]').textContent=offer.parent?config.upgrade:config.add;
      $('[data-offer-status]').textContent='';
    }
    function checkout(){
      if(mutating)return;
      dialog.close();
      // Keep cart notes entered in the cart form before navigating.
      const note=originForm?.querySelector('[name="note"]');
      if(note)api('cart/update.js',{note:note.value}).catch(()=>{}).finally(()=>location.assign(root+'checkout'));
      else location.assign(root+'checkout');
    }
    async function openOffer(trigger,form){
      if(loading || mutating || dialog.open)return;
      loading=true;returnFocus=trigger;originForm=form;
      if(trigger)trigger.setAttribute('aria-busy','true');
      try {
        snapshot=await api('cart.js');
        const offer=selectOffer(snapshot,config.offers);
        if(!offer){checkout();return;}
        render(offer);dialog.showModal();$('[data-offer-continue]').focus();
      } catch { checkout(); }
      finally {loading=false;trigger?.removeAttribute('aria-busy');}
    }
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[href]');
      if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button!==0)return;
      const url=new URL(link.href,location.href);
      if(url.origin===location.origin && /\/checkout\/?$/.test(url.pathname)){
        event.preventDefault();event.stopImmediatePropagation();openOffer(link,null);
      }
    },true);
    document.addEventListener('submit',event=>{
      const form=event.target,submitter=event.submitter;
      if(submitter?.name!=='checkout')return;
      const action=new URL(form.action,location.href);
      if(action.origin!==location.origin || !/\/cart\/?$/.test(action.pathname))return;
      event.preventDefault();event.stopImmediatePropagation();openOffer(submitter,form);
    },true);
    $('[data-offer-continue]').addEventListener('click',checkout);
    $('[data-offer-close]').addEventListener('click',()=>{if(!mutating){dialog.close();returnFocus?.focus();}});
    dialog.addEventListener('cancel',event=>{if(mutating)event.preventDefault();else returnFocus?.focus();});
    $('[data-offer-accept]').addEventListener('click',async()=>{
      if(mutating || !current)return;
      mutating=true;dialog.querySelectorAll('button').forEach(b=>b.disabled=true);$('[data-offer-status]').textContent=config.updating;
      try {
        const fresh=await api('cart.js');
        if(cartFingerprint(fresh)!==cartFingerprint(snapshot)){
          snapshot=fresh;const revised=selectOffer(fresh,config.offers);
          if(!revised){mutating=false;checkout();return;}
          render(revised);$('[data-offer-status]').textContent=config.changed;return;
        }
        if(current.parent)await api('cart/update.js',{updates:bundleUpdates(fresh,current)});
        else await api('cart/add.js',{items:current.missing.map(p=>({id:p.id,quantity:1}))});
        mutating=false;checkout();
      } catch(error) {
        $('[data-offer-status]').textContent=config.error;
        // Re-read after an error before any further attempt, preserving the real cart.
        try {snapshot=await api('cart.js');const revised=selectOffer(snapshot,config.offers);if(revised){render(revised);$('[data-offer-status]').textContent=config.error;}else current=null;}catch{current=null;}
      } finally {mutating=false;dialog.querySelectorAll('button').forEach(b=>b.disabled=false);$('[data-offer-accept]').disabled=!current;}
    });
  }
}
